<script>
import Vue from 'vue';
import bookingList from '../BookingList/BookingList.vue'
import bookingFilters from '../BookingFilters/BookingFilters.vue'
import store from '../../store'
import InfoWidget from '../InfoWidget/InfoWidget.vue';
import {mapState, mapActions} from 'vuex';

export default Vue.extend({
    components: {
        bookingList,
        bookingFilters,
        InfoWidget
    },
    computed: {
        ...mapState({
            tips: state => state.booking.bookings.tips,
            supplier: state => state.auth.supplier
        })
    },
    watch: {
        supplier: (supplier) => {
            store.dispatch('booking/getSupplierFilterData', supplier.id);
            store.dispatch('booking/getBookings', supplier.id);
        }
    },
    created () {
        this.getSupplierFilterData(this.supplier.id);
        this.getBookings(this.supplier.id);
    },
    beforeRouteLeave(to, from, next) {
        Promise.all([
            this.$refs.infoWidget.clean()
        ]).then(() => {
            next();
        });
    },
    destroyed() {
        this.resetState();
    },
    methods: {
        ...mapActions({
            resetState: 'booking/resetState',
            getBookings: 'booking/getBookings',
            getSupplierFilterData: 'booking/getSupplierFilterData'
        })
    }
});
</script>
<template>
    <div class="booking-page">
        <booking-filters/>
        <booking-list/>
        <info-widget ref="infoWidget" :tips="tips"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/BookingPage/BookingPage.vue